import React from "react";
import Flexbox from "flexbox-react";
import { FilledButton } from "../buttons-20250224T111359Z-001/buttons";

const SalaryCompensationSection = ({
  compensation,
  setCompensation,
  isAdmin,
  onSave
}) => {
  
  const updateField = (field, value) => {
    if (field === "annual_bonus_percentage") {
      if (Number(value) < 0 || Number(value) > 100) {
        ToastStore.showToast(
          "Annual bonus percentage must be between 0 and 100",
          "danger"
        );
        return;
      }
    }
  
    setCompensation(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="section-card">
      <div className="section-card-header">
        <div className="salary-card-title">
          <span>Compensation</span>
        </div>

        <div className="salary-section-count">
          Section 1 of 2
        </div>
      </div>

      <Flexbox display="flex" flexDirection="row" gap="24px" padding="20px" justifyContent="space-between">
        <Flexbox flexGrow={1} flexDirection="column" className="salary-field" marginRight="26px">
          <label>
            Annual Basic Salary
            <span className="required">
              (required)
            </span>
          </label>

          {isAdmin ? (
            <div className="salary-input-wrapper">
              <span className="salary-prefix">$</span>
              <input
                type="number"
                value={compensation.base_salary}
                onChange={e =>
                  updateField("base_salary",e.target.value)
                }
                placeholder="Enter Employee's annual basic salary"
              />            
            </div>
          ) : (
            <div className="readonly-input">
              $
              {compensation.base_salary}
            </div>
          )}
        </Flexbox>

        <Flexbox flexGrow={1} flexDirection="column" className="salary-field">
          <label>
            Bonus Percentage
            <span className="required">
              (required)
            </span>
          </label>

          {isAdmin ? (
            <div className="salary-input-wrapper">
              <input
                type="number"
                value={compensation.annual_bonus_percentage}
                placeholder="Enter Employee's quaterly bonus percentage"
                onChange={e =>
                  updateField(
                    "annual_bonus_percentage",
                    e.target.value
                  )
                }
              />
              <span className="salary-suffix">
                %
              </span>
            </div>
          ) : (
            <div className="readonly-input">
              {
                compensation.annual_bonus_percentage
              }
              %
            </div>
          )}
        </Flexbox>
      </Flexbox>

      <Flexbox display="flex" flexDirection="row" gap="24px" padding="20px" paddingTop="0" justifyContent="space-between">
        <Flexbox flexGrow={1} flexDirection="column" className="salary-field" marginRight="26px">
          <label>
            Annual Bonus Amount
          </label>
          <div className="readonly-input">
            ${compensation?.annual_bonus_amount || 0}
          </div>
        </Flexbox>

        <Flexbox flexGrow={1} flexDirection="column" className="salary-field">
          <label>
            Quarterly Bonus Amount
          </label>
          <div className="readonly-input">
            ${compensation?.quarterly_bonus_amount || 0}
          </div>
        </Flexbox>
      </Flexbox>

      {isAdmin && (
        <div className="salary-actions">
            <FilledButton text="Save" onClick={onSave} />        
        </div>
      )}
    </div>
  );
};

export default SalaryCompensationSection;